import React from 'react';
import find from 'lodash/find';
import { useSelector } from 'react-redux';
import defaultMessageConfig from '../../messages/messageConfig';
import { ACTION_ERROR_CODES } from '../../../../store/utils/handleErrors';
import BuildMessage from '../../messages/BuildMessage';

const { error: defaultError } = defaultMessageConfig;

// actions includes onUserLoginAction, handleInvalidTransactionAction
const ContainerAlert = ({ errorActions }) => {
  const { errorMsgCode, message: storeMessage } = useSelector(state => state.error);
  let message = storeMessage;
  const actionCode = find(ACTION_ERROR_CODES, c => c === errorMsgCode);
  if (actionCode) {
    message = defaultError[actionCode](errorActions);
  }

  return (
    <BuildMessage message={message} className="checkout-ui-container__page-message"/>
  );
};

export default ContainerAlert;
